import React from "react";
import { Link } from "react-router-dom";
import "../styles/breadcrumb-nav.css";

const BreadcrumbNav = ({ items = [] }) => {
  const validItems = items.filter(Boolean);

  if (!validItems.length) return null;

  return (
    <nav className="custom-breadcrumb-nav" aria-label="Navegación">
      <div className="site-shell">
        <div className="site-shell-inner">
          <ol className="custom-breadcrumb-list">
            <li className="custom-breadcrumb-item">
              <Link to="/">INICIO</Link>
            </li>

            {validItems.map((item, index) => {
              const isLast = index === validItems.length - 1;

              return (
                <li
                  key={`${item.label}-${index}`}
                  className={`custom-breadcrumb-item ${
                    isLast ? "active" : ""
                  }`}
                >
                  {item.to && !isLast ? (
                    <Link to={item.to}>{item.label}</Link>
                  ) : (
                    <span>{item.label}</span>
                  )}
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </nav>
  );
};

export default BreadcrumbNav;